import { Outlet } from "react-router";
import React from "react";

export default function AnnotateLayout() {
  return <Outlet />;
}
